module.exports = __webpack_public_path__ + "assets/img/icons8-ireland-144.e61083b0.png";